/**
 *
 * AmbassadorsSummary
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import SummaryScreen from "components/SummaryScreen"
import Loader from "components/Loader"
import { pick, get } from "lodash"
import { Modal, Button, Progress, Checkbox, Popover, Input, Select, Form } from "antd"
import {
  makeSelectSummary,
  makeSelectIsLoadingSummary,
  makeSelectPercentage,
  makeSelectLanguage,
} from "./selectors"
import {
  getAmbassadorsSummaryWatcher,
  uploadTemplateAmbassadorsWatcher,
  saveExcelAmbassadorsWatcher,
  getLanguageWatcher,
} from "./actions"
import reducer from "./reducer"
import saga from "./saga"
import check from "../../images/check.svg"
import { QuestionCircleFilled } from "@ant-design/icons"

import "./index.less"

/* eslint-disable react/prefer-stateless-function */
export class AmbassadorsSummary extends React.Component {
  state = { modalProgress: false, checkSendInvitation: true, id_language: undefined }

  UNSAFE_componentWillMount = () => {
    this.props.getAmbassadorsSummaryWatcher()
  }

  setChangeModal = (name, value) => {
    this.setState({ [name]: value })
  }
  constructor(props) {
    super(props)
    this.handleChangeLanguage = this.handleChangeLanguage.bind(this)
  }

  componentDidMount() {
    this.props.getLanguage && this.props.getLanguage()
  }
  handleChangeLanguage = (value) => {
    this.setState({ actual_language: value })
  }
  renderIconQuestion = () => {
    return (
      <Popover
        placement="top"
        content={
          <div style={{ maxWidth: 245, textAlign: "center" }}>
            El embajador recibirá un{" "}
            <b>
              correo de
              <br /> invitación
            </b>{" "}
            al sistema al ser asignado.
          </div>
        }>
        <QuestionCircleFilled className="AmbassadorsSummary-icon-question" />
      </Popover>
    )
  }
  verifyDisabledButton = () => {
    if(this.state.checkSendInvitation == true && this.state.actual_language == undefined){
      return true
    }
    if(this.state.checkSendInvitation == false){
      return false
    }
  }
  render() {
    let { checkSendInvitation } = this.state
    return (
      <React.Fragment>
        <Helmet>
          <title>Embajadores - Importación</title>
          <meta
            name="description"
            content="Description of AmbassadorsSummary"
          />
        </Helmet>
        {this.props.isLoadingSummary ? (
          <Loader />
        ) : (
          <div className="AmbassadorSummary-screen">
            <SummaryScreen
              gridHeader="220px 160px 120px 140px 1.5fr 40px"
              header={[
                "Correo electrónico",
                "Nombre",
                "Apellido",
                "División",
                "Error",
                "Fila",
              ]}
              gridContent="220px 160px 120px 140px 1.5fr 40px"
              content={[
                "email",
                "firstName",
                "lastName",
                "division",
                "messsage",
                "row",
              ]}
              uploadTemplate={this.props.uploadTemplateAmbassadorsWatcher}
              disabledButton={this.verifyDisabledButton}
              onFinalize={(params) => {
                this.setChangeModal("modalProgress", true)
                this.props.saveExcelAmbassadorsWatcher({ ...params, id_language: this.state.actual_language })
              }}
              maxWidthTable="90%"
              textResume={{
                text: "embajador",
                success: (
                  <React.Fragment>
                    <span>
                      {`${get(this.props.summary, "count_import", 0)} `}
                    </span>
                    {`${plural(
                      "embajador",
                      get(this.props.summary, "count_import", 0),
                      "es"
                    )} ${plural(
                      "asignado",
                      get(this.props.summary, "count_import", 0),
                      "s"
                    )}`}
                  </React.Fragment>
                ),
                failed: (
                  <React.Fragment>
                    <span>
                      {`${get(this.props.summary, "count_error", 0)} `}
                    </span>
                    {`${plural(
                      "embajador",
                      get(this.props.summary, "count_error", 0),
                      "es"
                    )} sin asignar`}
                  </React.Fragment>
                ),
              }}
              hasUpdates={false}
              history={this.props.history}
              urlBack="/control-panel#user-management"
              title="embajadores"
              backTitle="Gestión de usuarios"
              modalFinalize={
                <React.Fragment>
                  <span style={{ fontWeight: 600, fontSize: 14 }}>
                    ¿Estás seguro que deseas finalizar la asignación de
                    embajadores?
                  </span>
                  <p style={{ fontSize: 13, marginTop: 8 }}>
                    Si el checkbox está activado, se activará un correo de
                    invitación a la plataforma para los usuarios, quienes podrá
                    visualizar los resultados de su división, si es que
                    existieran.
                  </p>
                  <div className="AmbassadorsSummary-Ambassador-checkbox">
                    <Checkbox
                      onChange={(e) =>
                        this.setState({
                          checkSendInvitation: e.target.checked,
                        })
                      }
                      checked={checkSendInvitation}>
                      Enviar correo de invitación al sistema{" "}
                      {this.renderIconQuestion()}
                    </Checkbox>
                    {this.state.checkSendInvitation && (
                      <>
                        <Input.Group compact>
                          <Form.Item style={{ width: "60%", textAlign: "left", float: "left", marginTop: "5px", marginLeft: "10px" }}>
                            <Select
                              placeholder="Seleccionar idioma del correo"
                              value={this.state.actual_language}
                              style={{ width: "100%" }}
                              onChange={this.handleChangeLanguage}>
                              {/*  <Option value="Español">Español</Option> */}
                              {this.props.languages?.map((language) => (
                                <Select.Option
                                  key={`language-${language.id_language}`}
                                  value={language.id_language}>
                                  {language.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Input.Group>
                      </>
                    )}
                  </div>
                </React.Fragment>
              }
              {...pick(this.props.summary, [
                "count_import",
                "count_error",
                "listErrors",
              ])}
              checkSendInvitation={checkSendInvitation}
            />
          </div>
        )}

        <Modal
          visible={this.state.modalProgress}
          okText="Aceptar"
          closable={false}
          footer={
            this.props.percentage !== 100
              ? null
              : [
                <Button
                  key="submit"
                  type="primary"
                  onClick={() => {
                    this.setChangeModal("modalProgress", false)
                    this.props.history.push("/control-panel#user-management")
                  }}>
                  Aceptar
                </Button>,
              ]
          }
          width={520}>
          {this.props.percentage !== 100 ? (
            <div className="modalSuccess">
              <Progress
                style={{ margin: "0 auto" }}
                width={80}
                type="circle"
                percent={this.props.percentage}
              />
              <span
                style={{
                  justifySelf: "center",
                  alignSelf: "center",
                  marginTop: "1em",
                  fontSize: "14px",
                  color: "#555151",
                }}>
                La importación puede tardar unos minutos...
              </span>
            </div>
          ) : (
            <div className="modalSuccess" style={{ textAlign: "center" }}>
              <img src={check} />
              <span
                style={{ marginTop: 14, fontWeight: 600, color: "#555151" }}>
                La importación ha sido completada con éxito.
              </span>
              <span
                style={{
                  justifySelf: "center",
                  alignSelf: "center",
                  marginTop: "1em",
                  fontSize: "14px",
                  color: "#555151",
                }}>
                {this.state.checkSendInvitation ? 
                  <>Los embajadores serán notificados con un correo de bienvenida a
                  la plataforma, pero no podrán ver los resultados de la medición
                  hasta que esta sea oficializada.</> : 
                  <>Ahora podrás visualizar los embajadores de tu organización.</>} 
              </span>
            </div>
          )}
        </Modal>
      </React.Fragment>
    )
  }
}

AmbassadorsSummary.propTypes = {
  getAmbassadorsSummaryWatcher: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  summary: makeSelectSummary(),
  isLoadingSummary: makeSelectIsLoadingSummary(),
  percentage: makeSelectPercentage(),
  languages: makeSelectLanguage(),
})

function mapDispatchToProps(dispatch) {
  return {
    getAmbassadorsSummaryWatcher: () =>
      dispatch(getAmbassadorsSummaryWatcher()),
    uploadTemplateAmbassadorsWatcher: (params) =>
      dispatch(uploadTemplateAmbassadorsWatcher(params)),
    saveExcelAmbassadorsWatcher: (params) =>
      dispatch(saveExcelAmbassadorsWatcher(params)),
    getLanguage: (params) => dispatch(getLanguageWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "ambassadorsSummary", reducer })
const withSaga = injectSaga({ key: "ambassadorsSummary", saga })

export default compose(withReducer, withSaga, withConnect)(AmbassadorsSummary)
